<template>
  <div id="about" class="about">
    <headline>About</headline>
    <div id="logo">
      <div id="img">
        <img src="../../assets/images/logo.png" />
      </div>
      <div id="text">
        <p>
          「ここから紡ぐ、物語。」をテーマに、異世界から日本に迷い込んだ天ノ葉つむぎ・武者丸の日常をストーリー型の動画として投稿している団体です。
        </p>
        <div id="links">
          <a href="https://twitter.com/_habaki_" target="_blank" rel="noopener noreferrer"
            ><font-awesome-icon id="twitter" :icon="['fab', 'twitter']" />Twitter</a
          >
          <a href="https://www.youtube.com/channel/UC6sjImHi5w_9mVVfkXauF3g" target="_blank" rel="noopener noreferrer"
            ><font-awesome-icon id="youtube" :icon="['fab', 'youtube']" />YouTube</a
          >
        </div>
      </div>
    </div>
    <div id="videos">
      <iframe
        loading="lazy"
        src="https://www.youtube.com/embed/DI_cmNR2wWI"
        allow="fullscreen"
        referrerpolicy="no-referrer"
      ></iframe>
      <iframe
        loading="lazy"
        src="https://www.youtube.com/embed/?list=UU6sjImHi5w_9mVVfkXauF3g"
        allow="fullscreen"
        referrerpolicy="no-referrer"
      ></iframe>
    </div>
  </div>
</template>

<script>
import headline from './common/headline'
export default {
  name: 'About',
  components: { headline }
}
</script>

<style lang="scss" scoped>
@import '../../stylesheets/variables';

#logo {
  background-color: $black;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  padding: 5%;
  @media screen and (max-width: $break-point) {
    flex-flow: column nowrap;
  }

  #img {
    flex-basis: 40%;
    align-self: center;
    @media screen and (max-width: $break-point) {
      margin: 20px;
    }
    img {
      width: 100%;
    }
  }
  #text {
    flex-basis: 40%;
    color: $white;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-around;
    p {
      font-size: 16px;
      line-height: 23px;
      margin: 1em;
      @media screen and (max-width: $break-point) {
        font-size: 14px;
        line-height: 20px;
      }
    }
    #links {
      a {
        color: $white;
        display: inline-block;
        font-size: 24px;
        line-height: 34.75px;
        margin-right: 1.5em;
        text-decoration: none;
        #twitter {
          color: $twitter;
          margin: 0 9px;
        }
        #youtube {
          color: $youtube;
          margin: 0 9px;
        }
        @media screen and (max-width: $break-point) {
          font-size: 18px;
          line-height: 26px;
        }
      }
      @media screen and (max-width: $break-point) {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
      }
    }
  }
}
#videos {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-content: space-around;
  margin: 30px 0;
  iframe {
    min-width: 480px;
    min-height: 270px;
    border: none;
    margin: 10px;
  }
  @media screen and (max-width: $break-point) {
    display: none;
  }
}
</style>
